import { Node, mergeAttributes } from '@tiptap/core';

/**
 * Inline atom for a fill-in prompt the drafter must replace. Serialized as
 * <span data-fill="Label">[Label]</span>. Clicking selects the whole chip, so
 * typing replaces it — no custom handling needed.
 */
export const FillInNode = Node.create({
  name: 'fillIn',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      label: {
        default: 'Fill in',
        parseHTML: (element) => element.getAttribute('data-fill') || (element.textContent || '').replace(/^\[|\]$/g, ''),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-fill]' }];
  },

  renderHTML({ node }) {
    const label = node.attrs.label || 'Fill in';
    return [
      'span',
      mergeAttributes({
        'data-fill': label,
        class: 'fill-chip',
        title: 'Click and type to replace this prompt',
      }),
      `[${label}]`,
    ];
  },

  renderText({ node }) {
    return `[${node.attrs.label}]`;
  },
});

export default FillInNode;
